/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {CheckoutHeaderSkeleton} from "./CheckoutHeaderSkeleton";
import {CheckoutContentSkeleton} from "./CheckoutContentSkeleton";

export const CheckoutSkeleton = () => (
    <><CheckoutHeaderSkeleton/><CheckoutContentSkeleton/></>
)
